import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import Tooltip from '@atlaskit/tooltip';
import capitalize from 'lodash/capitalize';
import snakeCase from 'lodash/snakeCase';
import React from 'react';
import { Link as RouteLink } from 'react-router-dom';
import ViewReportIcon from "../Common/ViewReportIcon";
export const Cell = _styled("div", {
  target: "e1qmbj4s0",
  label: "Cell"
})(process.env.NODE_ENV === "production" ? {
  name: "o6l5fu",
  styles: "padding:5px 0;"
} : {
  name: "o6l5fu",
  styles: "padding:5px 0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const entitlementNumberTooltip = 'Entitlement number (EN) is a new ID for the entitlement of this customer. EN will replace SEN as the primary ID. During this transition, the customer can use SEN or EN.';
export const licenseTypesMap = {
  academic: 'Paid',
  commercial: 'Paid',
  community: 'Free',
  demonstration: 'Free',
  open_source: 'Free'
};
export const getLicenseReportHeader = () => ({
  cells: [{
    key: 'startDate',
    content: 'Start date',
    style: {
      minWidth: '95px'
    }
  }, {
    key: 'licenseId',
    content: 'License ID',
    style: {
      minWidth: '130px'
    }
  }, {
    key: 'entitlementNumber',
    content: /*#__PURE__*/React.createElement(Tooltip, {
      content: entitlementNumberTooltip
    }, /*#__PURE__*/React.createElement("span", null, "Entitlement number")),
    style: {
      minWidth: '135px'
    }
  }, {
    key: 'customer',
    content: 'Customer'
  }, {
    key: 'app',
    content: 'App',
    style: {
      minWidth: '230px'
    }
  }, {
    key: 'license',
    content: 'License'
  }, {
    key: 'endDate',
    content: 'End date',
    style: {
      minWidth: '140px'
    }
  }]
});
export const getLicenseReportBody = (licenses, getReportsLink, onLicenseClick) => {
  if (!licenses) {
    return [];
  }

  return licenses.map(license => {
    return {
      key: license.licenseId,
      cells: [{
        key: license.maintenanceStartDate,
        content: /*#__PURE__*/React.createElement(Cell, null, license.maintenanceStartDate)
      }, {
        key: license.licenseId,
        content: /*#__PURE__*/React.createElement(RouteLink, {
          to: getReportsLink('text', license.licenseId, 'licenseId')
        }, license.licenseId)
      }, {
        key: license.appEntitlementNumber,
        content: license.appEntitlementNumber || '--'
      }, {
        key: license.contactDetails.company,
        content: license.contactDetails.company ? /*#__PURE__*/React.createElement(RouteLink, {
          to: getReportsLink('text', license.contactDetails.company)
        }, license.contactDetails.company) : '--'
      }, {
        key: license.addonName,
        content: /*#__PURE__*/React.createElement(RouteLink, {
          to: getReportsLink('addon', license.addonKey)
        }, license.addonName)
      }, {
        key: license.licenseType,
        content: licenseTypesMap[snakeCase(license.licenseType)] || capitalize(license.licenseType)
      }, {
        key: license.maintenanceEndDate,
        content: /*#__PURE__*/React.createElement(ViewReportIcon, {
          columnValue: license.maintenanceEndDate,
          onClick: _ => onLicenseClick(license)
        })
      }]
    };
  });
};